@file:UseSerializers(UuidSerializer::class)

package it.neckar.lizergy.comments.client

import it.neckar.rest.RestRequest
import it.neckar.uuid.UuidSerializer
import kotlin.uuid.Uuid
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers

@Serializable
data class DuplicateCommentsRequest(val mapOfOldToNewUuids: Map<Uuid, Uuid>) : RestRequest
